<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { ModelListSelect } from "vue-search-select";
import { mapGetters,mapActions,mapState } from "vuex"
import moment from "moment";
import Swal from "sweetalert2";
import axios from 'axios';
import DataTable from "@/components/DataTable.vue";


/**
 * Advanced table component
 */
export default {
  page: {
    title: "Shop Purchases Report",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    ModelListSelect,
    DataTable,
  },
  data() {
    return {
      data: {
        datefrom: moment(new Date()).format("YYYY-MM-DD"),
        dateto: moment(new Date()).format("YYYY-MM-DD"),
        supplier: '',
        mode: '',
        user: '',
        title: 'Purchases Payments Report',
        page: 1,
        per_page: 50,
      },
      editdata:{
        id:"",
        amount:"",
        filterdata:{}
      },
      deletedata:{
        id:"",
        amount:"",
        filterdata:{}
      },
      currentdate: moment(new Date()).format("YYYY-MM-DD"),
      title: "Purchase Payments Report",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Purchases Payments Report",
          active: true,
        },
      ],
     
      pageOptions: [10, 25, 50, 100, 200, 1000],
      serverPerPage: 50,
      IsPurchasePaymentsDataServerPaginated: true,
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      purchasePaymentColumns: [
        {
          key: "sn",
          label: "S/N",
          formatter: (_, __, idx) => this.PurchasePaymentsDataPagination.from + idx,
        },
        {
          key: "date",
          label: "DATE",
        },
        {
          key: "supplier",
          label: "SUPPLIER",
        },
        {
          key: "amount",
          label: "AMOUNT",
          formatter: (v) => this.thousandSeperator(v),
        },
        {
          key: "receipt",
          label: "RECEIPT NO",
        },
        {
          key: "payments",
          label: "COUNT",
        },
        {
          key: "mode",
          label: "PAYMENT MODE",
        },
        {
          key: "dateAdded",
          label: "RECORDED ON",
        },
        {
          key: "user",
          label: "RECORDED BY",
        },
        {
          key: "actions",
          label: "ACTIONS",
          tdClass: "text-nowrap",
        },
      ],
      amountError: "",
    };
  },

  computed: {
    ...mapState("notification", [
      "type",
      "message",
      "show",
    ]),
    ...mapGetters("purchase", [
      "PurchasePaymentsData",
      "PurchasePaymentsDataPagination",
      "PurchasePaymentsDataSummary",
      "FilterStatus",
      "SaveStatus",
      "PurchasePaymentsDataPaginated"
    ]),
    ...mapGetters("stock", ["Suppliers"]),
    ...mapGetters("auth",["MyUserPerm","business","branch","Branches","branchid"]),
    ...mapGetters("users", ["Users"]),

    rows() {
      return this.IsPurchasePaymentsDataServerPaginated
        ? this.PurchasePaymentsDataPagination?.total
        : this.PurchasePaymentsData
        ? this.PurchasePaymentsData.length
        : 0;
    },

     perPage: {
      get() {
        if (this.IsPurchasePaymentsDataServerPaginated) {
          return (
            (this.PurchasePaymentsDataPagination &&
              this.PurchasePaymentsDataPagination.per_page) ||
            this.data.per_page ||
            this.serverPerPage
          );
        } else {
          return this.serverPerPage;
        }
      },
      set(value) {
        if (this.IsPurchasePaymentsDataServerPaginated) {
          this.data.per_page = value;
          this.data.page = 1;
          this.FetchPurchasePayments(this.data);
        } else {
          this.serverPerPage = value;
        }
      },
    },

    currentPage: {
      get() {
        return this.PurchasePaymentsDataPagination
          ? this.PurchasePaymentsDataPagination.current_page
          : 1;
      },
      set(value) {
        this.data.page = value;
        this.FetchPurchasePayments(this.data);
      },
    },


    totalAmount() {
      return this.PurchasePaymentsDataSummary ? this.PurchasePaymentsDataSummary.totalAmount : 0;
    }
  },

  methods: {
    ...mapActions({
      FetchPurchasePayments: "purchase/fetchPurchasePaymentsData",
      FetchSuppliers: "stock/fetchSuppliers",
      EditPayment: "purchase/EditPayment",
      DeletePayment: "purchase/DeletePayment",
      FetchUsers: "users/fetchUsers",
    }),


    thousandSeperator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
            .toString()
            .replace(/[^0-9.]+/g, "")
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },

    filterReport() {
      let payload = { ...this.data };
      payload.page = 1;
      payload.per_page = this.IsPurchasePaymentsDataServerPaginated
        ? this.perPage
        : this.serverPerPage;

      this.FetchPurchasePayments(payload);
    },

    handlePageChange(newPage) {
      if (this.IsPurchasePaymentsDataServerPaginated) {
        this.data.page = newPage;
        this.FetchPurchasePayments(this.data);
      }
    },

    editAmt(modalId){
      this.modal_id = modalId;
      if(this.editdata.amount==""){
        this.amountError = "Amount field is required";
        return
      }
      else{
        this.amountError = "";
      }
      this.editdata.filterdata = this.data;
      this.EditPayment(this.editdata);
    },

    deletePayment(modalId){
      this.modal_id = modalId;
      this.deletedata.filterdata = this.data;
      this.DeletePayment(this.deletedata);
    },

    addCommas() {
      this.editdata.amount = this.thousandSeperator(this.editdata.amount);
    },

    resetError(){
      this.amountError = "";
    },

    closeModal(modalId) {
      this.resetError();
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },

    showEditModal(data){
      this.editdata.amount = this.thousandSeperator(data.amount);
      this.editdata.id = data.id;
    },

    showDeleteModal(data){
      this.deletedata.id = data.id;
      this.deletedata.amount = this.thousandSeperator(data.amount);
    },

    resetDelete(){
      this.deletedata.id = "";
      this.deletedata.amount = "";
    },

    Excel_export() {
      axios
          .post("export_purchase_payments", this.data,{
            responseType: "arraybuffer",
          })
          .then((response) => {
            var fileURL = window.URL.createObjectURL(new Blob([response.data]));
            var fileLink = document.createElement("a");
            fileLink.href = fileURL;
            fileLink.setAttribute("download", "purchase_payments_report.xlsx");
            document.body.appendChild(fileLink);
            fileLink.click();
            this.spinner = false;
          })
          .catch(() => {
          });
    },
  },

  watch: {
    show(newValue) {
      if (newValue == true) {
        if (this.type == "success") {
          this.closeModal(this.modal_id);
          Swal.fire("Success!", this.message.msg, "success");
        } else {
          Swal.fire("Error!", this.message.msg, "error");
        }
      }
    },
  },

  created() {
    this.FetchPurchasePayments(this.data);
    this.FetchSuppliers();
    this.FetchUsers();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-9">
                <h3 class="card-title mb-2 text-center" v-html="data.title"></h3>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12 py-3">
                <b-button variant="info" @click="Excel_export()"
                ><i class="fa fa-download"></i> Export Excel</b-button
                >
              </div>
              <div class="col-md-3 form-group mb-2">
                <label>USERS</label>
                <model-list-select
                    :list="Users ? [ { id: '', names: 'All Users' }, ...Users ] : []"
                    v-model="data.user"
                    option-value="id"
                    option-text="names"
                    placeholder="Select User"
                    @input="filterReport()"
                >
                </model-list-select>
              </div>
              <div class="col-md-2 form-group mb-2">
                <label>FROM</label>
                <input
                    type="date"
                    v-model="data.datefrom"
                    class="form-control"
                    v-limit-future-date
                />
              </div>
              <div class="col-md-2 form-group">
                <label>TO</label>
                <input
                    v-model="data.dateto"
                    type="date"
                    class="form-control"
                    v-limit-future-date
                />
              </div>
              <div class="col-md-3 form-group">
                <label>SUPPLIER</label>
                <model-list-select
                    :list="Suppliers ? [ { id: '', name: 'All Suppliers' }, ...Suppliers ] : []"
                    v-model="data.supplier"
                    option-value="id"
                    option-text="name"
                    placeholder="Select Supplier"
                    @input="filterReport()"
                >
                </model-list-select>
              </div>
              <div class="col-md-2 mt-4">
                <button class="btn btn-primary" type="button" @click="filterReport()">
                  <span class="fa fa-filter"></span> Filter
                  <b-spinner
                      v-show="FilterStatus"
                      variant="light"
                      small
                      role="status"
                  ></b-spinner>
                </button>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                        class="form-select form-select-sm"
                        v-model="perPage"
                        size="sm"
                        :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-end"
                    v-if="!IsPurchasePaymentsDataServerPaginated"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                        v-model="filter"
                        type="search"
                        placeholder="Search..."
                        class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0"> 
             <DataTable
                :columns="purchasePaymentColumns"
                :rows="PurchasePaymentsData"
                :total-rows="rows"
                :pagination="PurchasePaymentsDataPagination"
                :server-pagination="IsPurchasePaymentsDataServerPaginated"
                :loading="FilterStatus"
                row-class="purchase-payment-bordered"
              >
                <!-- S/N -->
                <template #cell(sn)="{ index }">
                  {{ PurchasePaymentsDataPagination.from + index }}
                </template>

                <!-- DATE -->
                <template #cell(date)="{ value }">
                  {{ value }}
                </template>

                <!-- SUPPLIER -->
                <template #cell(supplier)="{ value }">
                  {{ value }}
                </template>

                <!-- AMOUNT -->
                <template #cell(amount)="{ value }">
                  {{ thousandSeperator(value) }}
                </template>

                <!-- RECEIPT -->
                <template #cell(receipt)="{ value }">
                  {{ value }}
                </template>

                <!-- PAYMENTS COUNT -->
                <template #cell(payments)="{ value }">
                  {{ value }}
                </template>

                <!-- PAYMENT MODE -->
                <template #cell(mode)="{ value }">
                  {{ value }}
                </template>

                <!-- DATE ADDED -->
                <template #cell(dateAdded)="{ value }">
                  {{ value }}
                </template>

                <!-- RECORDED BY -->
                <template #cell(user)="{ value }">
                  {{ value }}
                </template>

                <!-- ACTIONS -->
                <template #cell(actions)="{ row }">
                  <b-dropdown
                    text="More Actions..."
                    size="sm"
                    class="btn-primary"
                    v-if="MyUserPerm.modify_sales == 1"
                  >
                    <b-dropdown-item
                      v-if="MyUserPerm.delete_purchase == 1"
                      v-b-modal.delete-payment-modal
                      @click="showDeleteModal(row)"
                    >
                      <i class="fa fa-trash text-danger"></i>
                      <span class="text-danger"> Delete</span>
                    </b-dropdown-item>

                    <b-dropdown-item
                      v-if="MyUserPerm.edit_purchase == 1"
                      v-b-modal.edit-payment-modal
                      @click="showEditModal(row)"
                    >
                      <i class="fa fa-edit text-primary"></i>
                      <span class="text-primary"> Edit</span>
                    </b-dropdown-item>
                  </b-dropdown>
                </template>
              </DataTable>

              <div class="row">
                <div class="col-md-5"></div>
                <div class="col-md-4">
                  <h5>Total Amount: <span class="text-danger">{{thousandSeperator(totalAmount)}}</span></h5>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <div
                    class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                        aria-controls="payments-table"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>

            <!-- modals remain the same as original -->
            <b-modal id="edit-payment-modal" hide-footer>
              <template #modal-title>
                <h4 class="text-warning">Edit Purchase Payment</h4></template
              >
              <label>Amount Paid</label>
              <div class="input-group">
                <input
                    type="text"
                    class="form-control"
                    v-model="editdata.amount"
                    placeholder="Enter actual amount"
                    @input="resetError(),addCommas()"
                />
              </div>
              <div class="text-danger" v-if="amountError">
                <em>{{ amountError }}</em>
              </div>
              <div class="modal-footer">
                <button
                    type="button"
                    class="btn btn-secondary"
                    data-dismiss="modal"
                    @click="closeModal('edit-payment-modal')"
                >
                  <i class="fa fa-times"></i> Close
                </button>
                <button type="button" class="btn btn-warning" @click="editAmt('edit-payment-modal')">
                  <i class="fa fa-minus"></i> Confirm
                  <b-spinner
                      v-if="SaveStatus"
                      variant="light"
                      small
                      label="Submiting"
                  ></b-spinner>
                </button>
              </div>
            </b-modal>

            <b-modal
                header-bg-variant="danger"
                header-text-variant="light"
                body-text-variant="danger"
                footer-bg-variant="danger"
                footer-text-variant="danger"
                id="delete-payment-modal"
                hide-footer
                @hidden="resetDelete"
            >
              <template #modal-title> Delete Payment of amount {{ thousandSeperator(deletedata.amount) }}</template>
              <div class="form-group mb-2">
                <div class="input-group">
                  <h5>
                    Do you want to delete this Payment? Click Proceed Button to delete.
                  </h5>
                </div>
              </div>
              <div class="modal-footer">
                <button
                    type="button"
                    class="btn btn-secondary"
                    data-dismiss="modal"
                    @click="closeModal('delete-payment-modal')"
                >
                  <i class="fa fa-times"></i> Close
                </button>
                <button type="button" class="btn btn-danger" @click="deletePayment('delete-payment-modal')">
                  <i class="fa fa-minus"></i> Proceed
                  <b-spinner
                      v-if="SaveStatus"
                      variant="light"
                      small
                      label="Submiting"
                  ></b-spinner>
                </button>
              </div>
            </b-modal>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style>
.btn-primary,.page-link { background-color:#FAB031 !important;border-color:#FAB031 !important;}
</style>
